import { apiDaInscricao } from './axios';

export const obterTiposDeDeficiencia = async () => {
  const { data: tiposDeDeficiencia } = await apiDaInscricao().get('/TipoDeDeficiencia/obterTodos');
  return tiposDeDeficiencia;  
};